import { nodeComponentRegistry } from '../../../r3f/NodeComponentRegistry';
import { ReflectionProbe } from './Component';
nodeComponentRegistry.register({
    typeName: 'ReflectionProbe',
    Component: ReflectionProbe,
    editorIcon: { icon: 'GizmoReflectionProbe' },
});
//# sourceMappingURL=index.r3f.js.map